import { ApiService } from './apiService';
import { EstimateRequest, EstimateResult } from '../data/estimate';

export class EstimateService extends ApiService {
    public getEstimate(request: EstimateRequest): Promise<EstimateResult> {
        return this.makePostRequest<EstimateResult, EstimateRequest>('/estimate', request);
    }
}
